import { Route } from '@angular/router';
import { checkLoginStatus } from '@ay-gosu/ui/login/check-login-status';
import { LoginComponent } from '@ay-gosu/ui/login/login.component';
import { LoginStatus } from './login.service';

const routes: Route[] = [
  {
    path: '',
    component: LoginComponent,
    children: [
      {
        path: 'form',
        title: $localize`登入`,
        loadComponent: () => import('@ay-gosu/ui/login/form/form.component'),
      },
      {
        path: 'forgot-password',
        title: $localize`忘記密碼`,
        loadComponent: () =>
          import('@ay-gosu/ui/login/forgot-password/forgot-password.component'),
      },
      {
        path: 'register',
        title: $localize`註冊`,
        loadComponent: () =>
          import('@ay-gosu/ui/login/register/register.component'),
      },
      {
        path: 'verify-email',
        title: $localize`email驗證`,
        loadComponent: () =>
          import('@ay-gosu/ui/login/verify-email/verify-email.component'),
      },
      {
        path: 'phone-verify',
        title: $localize`手機驗證`,
        loadComponent: () =>
          import('@ay-gosu/ui/login/phone-verify/phone-verify.component'),
        canActivate: [
          checkLoginStatus([
            LoginStatus.NOT_CHOSEN_COMPANY,
            LoginStatus.LOGGED,
          ]),
        ],
      },
      {
        path: 'register-complete',
        title: $localize`註冊完成`,
        loadComponent: () =>
          import(
            '@ay-gosu/ui/login/register-complete/register-complete.component'
          ),
        canActivate: [
          checkLoginStatus([
            LoginStatus.NOT_CHOSEN_COMPANY,
            LoginStatus.LOGGED,
          ]),
        ],
      },
      {
        path: 'create-company',
        title: $localize`建立組織`,
        loadComponent: () =>
          import('@ay-gosu/ui/login/create-company/create-company.component'),
        canActivate: [
          checkLoginStatus([
            LoginStatus.NOT_CHOSEN_COMPANY,
            LoginStatus.LOGGED,
          ]),
        ],
      },
      {
        path: 'register-via-line',
        title: $localize`註冊`,
        loadComponent: () =>
          import(
            '@ay-gosu/ui/login/register-via-line/register-via-line.component'
          ),
      },
      {
        path: 'register-via-facebook',
        title: $localize`註冊`,
        loadComponent: () =>
          import(
            '@ay-gosu/ui/login/register-via-facebook/register-via-facebook.component'
          ),
      },
      {
        path: 'register-via-google',
        title: $localize`註冊`,
        loadComponent: () =>
          import(
            '@ay-gosu/ui/login/register-via-google/register-via-google.component'
          ),
      },
      {
        path: 'select-company',
        title: $localize`選擇組織`,
        loadComponent: () =>
          import('@ay-gosu/ui/login/select-company/select-company.component'),
        canActivate: [
          checkLoginStatus([
            LoginStatus.NOT_CHOSEN_COMPANY,
            LoginStatus.LOGGED,
          ]),
        ],
      },
      {
        path: 'reset-password',
        title: $localize`重設密碼`,
        loadComponent: () =>
          import('@ay-gosu/ui/login/reset-password/reset-password.component'),
      },
      {
        path: 'logout',
        title: $localize`登出`,
        loadComponent: () =>
          import('@ay-gosu/ui/login/logout/logout.component'),
        data: { state: 'logout' },
      },
      {
        path: 'invite',
        title: $localize`註冊邀請`,
        loadComponent: () =>
          import('@ay-gosu/ui/login/invite-register/invite-register.component'),
      },
      {
        path: '**',
        redirectTo: 'form',
        pathMatch: 'full',
      },
    ],
  },
];

export default routes;
